// ─────────────────────────────────────────────────────────────
//  FLEET MANAGEMENT DUMMY DATA
// ─────────────────────────────────────────────────────────────

export const fleetDummyData = {

  // ── Executive Summary ──────────────────────────────────────
  summary: {
    fleetHealthScore: 78,
    totalVehicles: 24,
    active: 14, idle: 6, maintenance: 3, offline: 1,
    onRoute: 12,
    fuelToday: 1840,         // litres
    fuelYesterday: 2110,
    costToday: 28500,        // ₹
    costMonth: 842000,
    criticalAlerts: 4,
    warningAlerts: 9,
    utilizationPct: 58,
    distanceToday: 3240,     // km across fleet
    co2Today: 4.8,           // tonnes
    avgSpeedFleet: 62,       // km/h
    tripsCompletedToday: 31,
    tripsInProgress: 12,
    aiInsights: [
      "TRK-005 shows abnormal vibration. Estimated breakdown risk in 12 days.",
      "Driver Arjun Singh idling 23% above fleet average. Fuel waste: ₹480/day.",
      "Route MUM→PUN via NH-48 consumes 18% more fuel than alternate NH-4.",
      "3 vehicles due for service in next 7 days. Schedule now to avoid downtime.",
      "Fleet CO₂ today is 12% below monthly average. Eco-driving in effect.",
    ],
  },

  // ── Vehicle List ───────────────────────────────────────────
  vehicles: [
    {
      id: "TRK-001", name: "Truck 01", type: "Heavy Truck", plateNo: "MH-12-AB-1234",
      driver: "Ravi Kumar",     driverScore: 88,
      status: "Active",    route: "Mumbai → Pune",       eta: "1h 45m",
      location: "NH-48, Khopoli", x: 28, y: 42, lat: 18.787, lng: 73.362,
      speed: 74, rpm: 1820, engineTemp: 86, battery: 13.8, fuel: 68,
      odometer: 142850, idleTime: 12, brakeUsage: "Normal",
      healthScore: 85, failureRisk: 12, lastService: "12 days ago", nextService: "In 18 days",
      alerts: [],
    },
    {
      id: "TRK-002", name: "Truck 02", type: "Heavy Truck", plateNo: "MH-12-AB-1235",
      driver: "Suresh Nair",    driverScore: 72,
      status: "Active",    route: "Pune → Nashik",        eta: "2h 30m",
      location: "Pune Bypass", x: 42, y: 50, lat: 18.570, lng: 73.920,
      speed: 61, rpm: 1650, engineTemp: 91, battery: 13.6, fuel: 44,
      odometer: 98420, idleTime: 28, brakeUsage: "Normal",
      healthScore: 74, failureRisk: 31, lastService: "28 days ago", nextService: "In 2 days",
      alerts: ["Service due in 2 days", "Low fuel – refill recommended"],
    },
    {
      id: "TRK-003", name: "Truck 03", type: "Medium Truck", plateNo: "MH-12-AC-3456",
      driver: "Priya Mehta",    driverScore: 94,
      status: "Active",    route: "Nashik → Shirdi",      eta: "55m",
      location: "Sinnar, NH-160", x: 35, y: 20, lat: 19.850, lng: 74.005,
      speed: 68, rpm: 1720, engineTemp: 82, battery: 14.1, fuel: 81,
      odometer: 67300, idleTime: 5, brakeUsage: "Normal",
      healthScore: 92, failureRisk: 5, lastService: "3 days ago", nextService: "In 27 days",
      alerts: [],
    },
    {
      id: "TRK-004", name: "Truck 04", type: "Heavy Truck", plateNo: "MH-14-BD-5678",
      driver: "Anjali Rao",     driverScore: 81,
      status: "Active",    route: "Mumbai → Aurangabad",  eta: "3h 10m",
      location: "Igatpuri Ghat", x: 22, y: 28, lat: 19.697, lng: 73.566,
      speed: 45, rpm: 1480, engineTemp: 94, battery: 13.5, fuel: 55,
      odometer: 211400, idleTime: 8, brakeUsage: "Moderate",
      healthScore: 70, failureRisk: 38, lastService: "42 days ago", nextService: "Overdue",
      alerts: ["Overdue service", "High engine temperature"],
    },
    {
      id: "TRK-005", name: "Truck 05", type: "Heavy Truck", plateNo: "MH-14-BD-5679",
      driver: "Vikram Patel",   driverScore: 65,
      status: "Active",    route: "Aurangabad → Solapur", eta: "4h 05m",
      location: "Aurangabad Ring Road", x: 62, y: 22, lat: 19.870, lng: 75.360,
      speed: 55, rpm: 2180, engineTemp: 98, battery: 13.2, fuel: 38,
      odometer: 189600, idleTime: 42, brakeUsage: "High",
      healthScore: 48, failureRisk: 78, lastService: "67 days ago", nextService: "Overdue – URGENT",
      alerts: ["Critical: Abnormal vibration detected", "Engine overheating risk", "Overdue service – URGENT", "High idle time"],
    },
    {
      id: "TRK-006", name: "Truck 06", type: "Light Truck", plateNo: "MH-09-CE-7890",
      driver: "Deepak Sharma",  driverScore: 90,
      status: "Active",    route: "Thane → Nashik",       eta: "1h 20m",
      location: "Kasara Ghat", x: 18, y: 25, lat: 19.742, lng: 73.408,
      speed: 52, rpm: 1580, engineTemp: 79, battery: 14.2, fuel: 76,
      odometer: 54800, idleTime: 7, brakeUsage: "Normal",
      healthScore: 94, failureRisk: 4, lastService: "8 days ago", nextService: "In 22 days",
      alerts: [],
    },
    {
      id: "TRK-007", name: "Truck 07", type: "Medium Truck", plateNo: "MH-09-CF-2345",
      driver: "Meena Joshi",    driverScore: 77,
      status: "Active",    route: "Solapur → Pune",       eta: "3h 40m",
      location: "Solapur Bypass", x: 68, y: 58, lat: 17.700, lng: 75.920,
      speed: 69, rpm: 1760, engineTemp: 88, battery: 13.9, fuel: 52,
      odometer: 132100, idleTime: 19, brakeUsage: "Normal",
      healthScore: 80, failureRisk: 22, lastService: "19 days ago", nextService: "In 11 days",
      alerts: [],
    },
    {
      id: "VAN-001", name: "Van 01", type: "Cargo Van", plateNo: "MH-02-DF-4567",
      driver: "Kiran Desai",    driverScore: 86,
      status: "Active",    route: "Mumbai → Thane",       eta: "35m",
      location: "Eastern Express Hwy", x: 14, y: 36, lat: 19.110, lng: 72.905,
      speed: 48, rpm: 1420, engineTemp: 75, battery: 12.9, fuel: 88,
      odometer: 28900, idleTime: 14, brakeUsage: "Normal",
      healthScore: 96, failureRisk: 3, lastService: "2 days ago", nextService: "In 28 days",
      alerts: [],
    },
    {
      id: "VAN-002", name: "Van 02", type: "Cargo Van", plateNo: "MH-02-DF-4568",
      driver: "Sonal Patil",    driverScore: 79,
      status: "Active",    route: "Navi Mumbai → Pune",   eta: "2h 10m",
      location: "Panvel, NH-48", x: 20, y: 46, lat: 18.989, lng: 73.110,
      speed: 71, rpm: 1810, engineTemp: 83, battery: 13.7, fuel: 61,
      odometer: 41200, idleTime: 11, brakeUsage: "Normal",
      healthScore: 89, failureRisk: 9, lastService: "15 days ago", nextService: "In 15 days",
      alerts: [],
    },
    {
      id: "TRK-008", name: "Truck 08", type: "Heavy Truck", plateNo: "MH-14-EG-6789",
      driver: "Arjun Singh",    driverScore: 58,
      status: "Active",    route: "Pune → Solapur",       eta: "3h 55m",
      location: "Jejuri, NH-65", x: 50, y: 54, lat: 18.273, lng: 74.158,
      speed: 58, rpm: 1690, engineTemp: 89, battery: 13.4, fuel: 47,
      odometer: 176800, idleTime: 55, brakeUsage: "Moderate",
      healthScore: 68, failureRisk: 42, lastService: "35 days ago", nextService: "In 5 days",
      alerts: ["Excessive idling (55 min)", "Service due soon"],
    },
    {
      id: "TRK-009", name: "Truck 09", type: "Medium Truck", plateNo: "MH-12-FH-8901",
      driver: "Neha Kulkarni",  driverScore: 92,
      status: "Active",    route: "Nashik → Mumbai",      eta: "2h 05m",
      location: "Bhivpuri, NH-160", x: 24, y: 32, lat: 19.370, lng: 73.370,
      speed: 66, rpm: 1700, engineTemp: 80, battery: 14.0, fuel: 74,
      odometer: 88500, idleTime: 6, brakeUsage: "Normal",
      healthScore: 91, failureRisk: 7, lastService: "6 days ago", nextService: "In 24 days",
      alerts: [],
    },
    {
      id: "EV-001", name: "EV Truck 01", type: "EV Truck", plateNo: "MH-02-GI-1122",
      driver: "Rahul Verma",    driverScore: 95,
      status: "Active",    route: "Mumbai → Pune",        eta: "2h 20m",
      location: "Khalapur Toll", x: 25, y: 45, lat: 18.840, lng: 73.278,
      speed: 80, rpm: 0, engineTemp: 42, battery: 72, fuel: null,
      odometer: 18400, idleTime: 3, brakeUsage: "Regen",
      healthScore: 97, failureRisk: 2, lastService: "1 day ago", nextService: "In 29 days",
      alerts: [], isEV: true, chargingCycles: 142, range: 210,
    },
    {
      id: "TRK-010", name: "Truck 10", type: "Heavy Truck", plateNo: "MH-14-HJ-3344",
      driver: "Ganesh More",    driverScore: 83,
      status: "Active",    route: "Shirdi → Nashik",      eta: "1h 10m",
      location: "Sinnar Junction", x: 40, y: 18, lat: 19.858, lng: 74.003,
      speed: 63, rpm: 1640, engineTemp: 84, battery: 13.9, fuel: 62,
      odometer: 124300, idleTime: 10, brakeUsage: "Normal",
      healthScore: 84, failureRisk: 16, lastService: "22 days ago", nextService: "In 8 days",
      alerts: [],
    },
    {
      id: "TRK-011", name: "Truck 11", type: "Light Truck", plateNo: "MH-09-IK-5566",
      driver: "Pooja Shah",     driverScore: 88,
      status: "Active",    route: "Thane → Mumbai",       eta: "45m",
      location: "LBS Marg, Thane", x: 16, y: 33, lat: 19.197, lng: 72.965,
      speed: 38, rpm: 1320, engineTemp: 72, battery: 14.1, fuel: 91,
      odometer: 31600, idleTime: 22, brakeUsage: "Normal",
      healthScore: 95, failureRisk: 4, lastService: "5 days ago", nextService: "In 25 days",
      alerts: [],
    },
    // Idle vehicles
    {
      id: "TRK-012", name: "Truck 12", type: "Heavy Truck", plateNo: "MH-12-JL-7788",
      driver: "Santosh Bhosle", driverScore: 76,
      status: "Idle",     route: "—",                    eta: "—",
      location: "Mumbai Depot", x: 10, y: 38, lat: 19.076, lng: 72.878,
      speed: 0, rpm: 850, engineTemp: 65, battery: 13.6, fuel: 95,
      odometer: 204500, idleTime: 87, brakeUsage: "—",
      healthScore: 77, failureRisk: 24, lastService: "18 days ago", nextService: "In 12 days",
      alerts: ["Excessive engine idle at depot"],
    },
    {
      id: "TRK-013", name: "Truck 13", type: "Medium Truck", plateNo: "MH-14-KM-9900",
      driver: "Unassigned",     driverScore: null,
      status: "Idle",     route: "—",                    eta: "—",
      location: "Pune Depot",  x: 42, y: 52, lat: 18.520, lng: 73.857,
      speed: 0, rpm: 0, engineTemp: 28, battery: 12.8, fuel: 100,
      odometer: 72100, idleTime: 0, brakeUsage: "—",
      healthScore: 88, failureRisk: 10, lastService: "10 days ago", nextService: "In 20 days",
      alerts: [],
    },
    {
      id: "VAN-003", name: "Van 03", type: "Cargo Van", plateNo: "MH-02-LN-1234",
      driver: "Unassigned",     driverScore: null,
      status: "Idle",     route: "—",                    eta: "—",
      location: "Nashik Depot", x: 30, y: 14, lat: 20.000, lng: 73.780,
      speed: 0, rpm: 0, engineTemp: 30, battery: 13.1, fuel: 88,
      odometer: 49800, idleTime: 0, brakeUsage: "—",
      healthScore: 90, failureRisk: 8, lastService: "14 days ago", nextService: "In 16 days",
      alerts: [],
    },
    {
      id: "TRK-014", name: "Truck 14", type: "Heavy Truck", plateNo: "MH-09-MO-5678",
      driver: "Dinesh Rao",     driverScore: 74,
      status: "Idle",     route: "—",                    eta: "—",
      location: "Thane Depot",  x: 14, y: 30, lat: 19.205, lng: 72.971,
      speed: 0, rpm: 720, engineTemp: 58, battery: 13.4, fuel: 72,
      odometer: 163200, idleTime: 45, brakeUsage: "—",
      healthScore: 75, failureRisk: 28, lastService: "31 days ago", nextService: "In 4 days",
      alerts: ["Service due in 4 days"],
    },
    {
      id: "EV-002", name: "EV Van 01", type: "EV Van", plateNo: "MH-02-NP-9012",
      driver: "Unassigned",     driverScore: null,
      status: "Idle",     route: "—",                    eta: "—",
      location: "Mumbai Depot", x: 10, y: 36, lat: 19.079, lng: 72.880,
      speed: 0, rpm: 0, engineTemp: 28, battery: 45, fuel: null,
      odometer: 8200, idleTime: 0, brakeUsage: "—",
      healthScore: 99, failureRisk: 1, lastService: "1 day ago", nextService: "In 29 days",
      alerts: [], isEV: true, chargingCycles: 48, range: 134,
    },
    {
      id: "TRK-015", name: "Truck 15", type: "Light Truck", plateNo: "MH-12-OP-3456",
      driver: "Unassigned",     driverScore: null,
      status: "Idle",     route: "—",                    eta: "—",
      location: "Aurangabad Depot", x: 60, y: 20, lat: 19.877, lng: 75.343,
      speed: 0, rpm: 0, engineTemp: 32, battery: 13.9, fuel: 100,
      odometer: 22400, idleTime: 0, brakeUsage: "—",
      healthScore: 97, failureRisk: 2, lastService: "4 days ago", nextService: "In 26 days",
      alerts: [],
    },
    // Maintenance
    {
      id: "TRK-016", name: "Truck 16", type: "Heavy Truck", plateNo: "MH-14-PQ-7890",
      driver: "In Service",     driverScore: null,
      status: "Maintenance", route: "—",                 eta: "—",
      location: "Authorized Workshop, Pune", x: 40, y: 56, lat: 18.522, lng: 73.855,
      speed: 0, rpm: 0, engineTemp: 0, battery: 12.5, fuel: 20,
      odometer: 248900, idleTime: 0, brakeUsage: "—",
      healthScore: 32, failureRisk: 92, lastService: "—", nextService: "Under Service",
      alerts: ["Engine overhaul in progress"],
    },
    {
      id: "TRK-017", name: "Truck 17", type: "Medium Truck", plateNo: "MH-09-QR-1234",
      driver: "In Service",     driverScore: null,
      status: "Maintenance", route: "—",                 eta: "—",
      location: "Fleet Workshop, Mumbai", x: 10, y: 42, lat: 19.073, lng: 72.882,
      speed: 0, rpm: 0, engineTemp: 0, battery: 13.0, fuel: 35,
      odometer: 145600, idleTime: 0, brakeUsage: "—",
      healthScore: 55, failureRisk: 65, lastService: "—", nextService: "Under Service",
      alerts: ["Brake replacement", "Tire change"],
    },
    {
      id: "TRK-018", name: "Truck 18", type: "Light Truck", plateNo: "MH-12-RS-5678",
      driver: "In Service",     driverScore: null,
      status: "Maintenance", route: "—",                 eta: "—",
      location: "Fleet Workshop, Nashik", x: 28, y: 16, lat: 19.998, lng: 73.783,
      speed: 0, rpm: 0, engineTemp: 0, battery: 12.8, fuel: 55,
      odometer: 89100, idleTime: 0, brakeUsage: "—",
      healthScore: 61, failureRisk: 50, lastService: "—", nextService: "Under Service",
      alerts: ["Transmission inspection"],
    },
    // Offline
    {
      id: "TRK-019", name: "Truck 19", type: "Heavy Truck", plateNo: "MH-14-ST-9012",
      driver: "Unassigned",     driverScore: null,
      status: "Offline",   route: "—",                   eta: "—",
      location: "Unknown",     x: 55, y: 48, lat: 17.690, lng: 75.910,
      speed: 0, rpm: 0, engineTemp: 0, battery: 11.8, fuel: 30,
      odometer: 312400, idleTime: 0, brakeUsage: "—",
      healthScore: 28, failureRisk: 95, lastService: "120+ days ago", nextService: "Overdue",
      alerts: ["GPS offline", "Battery critically low", "Overdue service"],
    },
  ],

  // ── SVG Map – Road Network ──────────────────────────────────
  // viewBox="0 0 100 70"
  mapLocations: [
    { id: "MUM", name: "Mumbai",      x: 10, y: 38, type: "depot"  },
    { id: "THN", name: "Thane",       x: 16, y: 32, type: "stop"   },
    { id: "NVM", name: "Navi Mumbai", x: 18, y: 46, type: "stop"   },
    { id: "PNV", name: "Panvel",      x: 20, y: 50, type: "stop"   },
    { id: "LON", name: "Lonavala",    x: 28, y: 44, type: "stop"   },
    { id: "PUN", name: "Pune",        x: 40, y: 54, type: "depot"  },
    { id: "NSK", name: "Nashik",      x: 30, y: 14, type: "depot"  },
    { id: "SHR", name: "Shirdi",      x: 44, y: 12, type: "stop"   },
    { id: "AUR", name: "Aurangabad",  x: 62, y: 20, type: "depot"  },
    { id: "SOL", name: "Solapur",     x: 68, y: 60, type: "stop"   },
    { id: "IGT", name: "Igatpuri",    x: 22, y: 26, type: "stop"   },
    { id: "KSR", name: "Kasara",      x: 18, y: 24, type: "stop"   },
  ],
  mapRoads: [
    // NH-48 (Mumbai–Pune)
    { from: "MUM", to: "NVM", label: "NH-48" },
    { from: "NVM", to: "PNV" },
    { from: "PNV", to: "LON" },
    { from: "LON", to: "PUN" },
    // Mumbai–Nashik
    { from: "MUM", to: "THN" },
    { from: "THN", to: "KSR", label: "NH-160" },
    { from: "KSR", to: "IGT" },
    { from: "IGT", to: "NSK" },
    // Nashik–Shirdi–Aurangabad
    { from: "NSK", to: "SHR", label: "NH-160" },
    { from: "SHR", to: "AUR" },
    // Pune–Solapur
    { from: "PUN", to: "SOL", label: "NH-65" },
    // Aurangabad–Solapur
    { from: "AUR", to: "SOL" },
  ],

  // ── Driver Behavior ────────────────────────────────────────
  drivers: [
    { id: "DRV-001", name: "Rahul Verma",    vehicleId: "EV-001",  score: 95, harshBraking: 0, rapidAccel: 0, overspeed: 0, nightDriving: 0, idleExcess: 3,  kmToday: 188, trips: 2, badge: "Top Driver"    },
    { id: "DRV-002", name: "Priya Mehta",    vehicleId: "TRK-003", score: 94, harshBraking: 1, rapidAccel: 0, overspeed: 0, nightDriving: 0, idleExcess: 5,  kmToday: 142, trips: 3, badge: "Safe Driver"   },
    { id: "DRV-003", name: "Neha Kulkarni",  vehicleId: "TRK-009", score: 92, harshBraking: 0, rapidAccel: 1, overspeed: 0, nightDriving: 0, idleExcess: 6,  kmToday: 168, trips: 3, badge: "Safe Driver"   },
    { id: "DRV-004", name: "Deepak Sharma",  vehicleId: "TRK-006", score: 90, harshBraking: 1, rapidAccel: 0, overspeed: 0, nightDriving: 0, idleExcess: 7,  kmToday: 112, trips: 2, badge: "Safe Driver"   },
    { id: "DRV-005", name: "Pooja Shah",     vehicleId: "TRK-011", score: 88, harshBraking: 1, rapidAccel: 1, overspeed: 0, nightDriving: 0, idleExcess: 22, kmToday: 48,  trips: 2, badge: "Good Driver"   },
    { id: "DRV-006", name: "Ravi Kumar",     vehicleId: "TRK-001", score: 88, harshBraking: 2, rapidAccel: 1, overspeed: 0, nightDriving: 0, idleExcess: 12, kmToday: 148, trips: 3, badge: "Good Driver"   },
    { id: "DRV-007", name: "Kiran Desai",    vehicleId: "VAN-001", score: 86, harshBraking: 1, rapidAccel: 2, overspeed: 1, nightDriving: 0, idleExcess: 14, kmToday: 62,  trips: 4, badge: "Good Driver"   },
    { id: "DRV-008", name: "Ganesh More",    vehicleId: "TRK-010", score: 83, harshBraking: 2, rapidAccel: 1, overspeed: 0, nightDriving: 0, idleExcess: 10, kmToday: 124, trips: 2, badge: "Good Driver"   },
    { id: "DRV-009", name: "Anjali Rao",     vehicleId: "TRK-004", score: 81, harshBraking: 3, rapidAccel: 2, overspeed: 0, nightDriving: 0, idleExcess: 8,  kmToday: 136, trips: 2, badge: "Average"       },
    { id: "DRV-010", name: "Sonal Patil",    vehicleId: "VAN-002", score: 79, harshBraking: 2, rapidAccel: 3, overspeed: 1, nightDriving: 0, idleExcess: 11, kmToday: 88,  trips: 3, badge: "Average"       },
    { id: "DRV-011", name: "Meena Joshi",    vehicleId: "TRK-007", score: 77, harshBraking: 4, rapidAccel: 2, overspeed: 1, nightDriving: 1, idleExcess: 19, kmToday: 210, trips: 2, badge: "Average"       },
    { id: "DRV-012", name: "Suresh Nair",    vehicleId: "TRK-002", score: 72, harshBraking: 5, rapidAccel: 3, overspeed: 2, nightDriving: 0, idleExcess: 28, kmToday: 102, trips: 2, badge: "Below Average" },
    { id: "DRV-013", name: "Santosh Bhosle", vehicleId: "TRK-012", score: 76, harshBraking: 3, rapidAccel: 2, overspeed: 1, nightDriving: 0, idleExcess: 87, kmToday: 0,   trips: 0, badge: "Average"       },
    { id: "DRV-014", name: "Dinesh Rao",     vehicleId: "TRK-014", score: 74, harshBraking: 4, rapidAccel: 3, overspeed: 2, nightDriving: 1, idleExcess: 45, kmToday: 0,   trips: 0, badge: "Average"       },
    { id: "DRV-015", name: "Arjun Singh",    vehicleId: "TRK-008", score: 58, harshBraking: 8, rapidAccel: 6, overspeed: 5, nightDriving: 2, idleExcess: 55, kmToday: 184, trips: 2, badge: "Needs Coaching" },
    { id: "DRV-016", name: "Vikram Patel",   vehicleId: "TRK-005", score: 65, harshBraking: 6, rapidAccel: 5, overspeed: 4, nightDriving: 1, idleExcess: 42, kmToday: 168, trips: 2, badge: "Below Average" },
  ],

  // ── Fuel & Cost Analytics ──────────────────────────────────
  fuel: {
    todayTotal: 1840,
    weeklyTrend: [
      { d: "Mon", litres: 2110, cost: 32800 },
      { d: "Tue", litres: 1980, cost: 30740 },
      { d: "Wed", litres: 2240, cost: 34760 },
      { d: "Thu", litres: 1760, cost: 27340 },
      { d: "Fri", litres: 2050, cost: 31840 },
      { d: "Sat", litres: 1420, cost: 22050 },
      { d: "Sun", litres: 1840, cost: 28580 },
    ],
    costPerKm: 8.8,          // ₹
    avgEfficiency: 4.2,      // km/litre
    idlingLoss: 142,         // litres/day wasted in idle
    idlingCost: 2200,        // ₹/day
    topConsumers: [
      { vehicleId: "TRK-005", name: "Truck 05", litres: 198, cost: 3080, efficiency: 2.8 },
      { vehicleId: "TRK-016", name: "Truck 16", litres: 0,   cost: 0,    efficiency: 0   },
      { vehicleId: "TRK-008", name: "Truck 08", litres: 162, cost: 2520, efficiency: 3.5 },
      { vehicleId: "TRK-004", name: "Truck 04", litres: 148, cost: 2300, efficiency: 3.8 },
      { vehicleId: "TRK-001", name: "Truck 01", litres: 128, cost: 1990, efficiency: 4.1 },
    ],
    aiSuggestions: [
      "Optimize Route NH-48 to reduce fuel by 18%. Switch to NH-4 via Khopoli.",
      "Reduce fleet idle time from 4.2h to 1h/day. Save ₹1,800/day in fuel.",
      "EV-001 saving ₹2,400/day vs equivalent diesel truck on same route.",
      "Schedule TRK-005 for immediate maintenance. Fuel efficiency dropped 33%.",
    ],

    // ── Per-Vehicle Fuel Usage (today) ──────────────────────
    vehicleFuel: [
      { vehicleId: "TRK-005", name: "Truck 05", type: "Heavy Truck",  driver: "Vikram Patel",   litres: 198, cost: 3080, efficiency: 2.8, kmDriven: 168, idleLitres: 42 },
      { vehicleId: "TRK-008", name: "Truck 08", type: "Heavy Truck",  driver: "Arjun Singh",    litres: 162, cost: 2520, efficiency: 3.5, kmDriven: 184, idleLitres: 38 },
      { vehicleId: "TRK-004", name: "Truck 04", type: "Heavy Truck",  driver: "Anjali Rao",     litres: 148, cost: 2300, efficiency: 3.8, kmDriven: 136, idleLitres: 18 },
      { vehicleId: "TRK-001", name: "Truck 01", type: "Heavy Truck",  driver: "Ravi Kumar",     litres: 128, cost: 1990, efficiency: 4.1, kmDriven: 148, idleLitres: 12 },
      { vehicleId: "TRK-007", name: "Truck 07", type: "Medium Truck", driver: "Meena Joshi",    litres: 118, cost: 1830, efficiency: 3.9, kmDriven: 210, idleLitres: 14 },
      { vehicleId: "TRK-002", name: "Truck 02", type: "Heavy Truck",  driver: "Suresh Nair",    litres: 112, cost: 1740, efficiency: 3.6, kmDriven: 102, idleLitres: 22 },
      { vehicleId: "TRK-009", name: "Truck 09", type: "Medium Truck", driver: "Neha Kulkarni",  litres: 104, cost: 1615, efficiency: 4.4, kmDriven: 168, idleLitres: 5  },
      { vehicleId: "TRK-003", name: "Truck 03", type: "Medium Truck", driver: "Priya Mehta",    litres: 98,  cost: 1520, efficiency: 4.6, kmDriven: 142, idleLitres: 4  },
      { vehicleId: "TRK-010", name: "Truck 10", type: "Heavy Truck",  driver: "Ganesh More",    litres: 94,  cost: 1460, efficiency: 4.0, kmDriven: 124, idleLitres: 8  },
      { vehicleId: "TRK-006", name: "Truck 06", type: "Light Truck",  driver: "Deepak Sharma",  litres: 82,  cost: 1275, efficiency: 4.8, kmDriven: 112, idleLitres: 6  },
      { vehicleId: "VAN-002", name: "Van 02",   type: "Cargo Van",    driver: "Sonal Patil",    litres: 76,  cost: 1180, efficiency: 4.2, kmDriven: 88,  idleLitres: 7  },
      { vehicleId: "VAN-001", name: "Van 01",   type: "Cargo Van",    driver: "Kiran Desai",    litres: 68,  cost: 1055, efficiency: 4.5, kmDriven: 62,  idleLitres: 9  },
      { vehicleId: "TRK-011", name: "Truck 11", type: "Light Truck",  driver: "Pooja Shah",     litres: 58,  cost: 900,  efficiency: 4.7, kmDriven: 48,  idleLitres: 10 },
      { vehicleId: "TRK-012", name: "Truck 12", type: "Heavy Truck",  driver: "Santosh Bhosle", litres: 52,  cost: 808,  efficiency: 0,   kmDriven: 0,   idleLitres: 52 },
      { vehicleId: "TRK-014", name: "Truck 14", type: "Heavy Truck",  driver: "Dinesh Rao",     litres: 38,  cost: 590,  efficiency: 0,   kmDriven: 0,   idleLitres: 38 },
      { vehicleId: "TRK-017", name: "Truck 17", type: "Medium Truck", driver: "In Service",     litres: 24,  cost: 373,  efficiency: 0,   kmDriven: 0,   idleLitres: 0  },
      { vehicleId: "TRK-013", name: "Truck 13", type: "Medium Truck", driver: "Unassigned",     litres: 0,   cost: 0,    efficiency: 0,   kmDriven: 0,   idleLitres: 0  },
      { vehicleId: "TRK-015", name: "Truck 15", type: "Light Truck",  driver: "Unassigned",     litres: 0,   cost: 0,    efficiency: 0,   kmDriven: 0,   idleLitres: 0  },
      { vehicleId: "TRK-018", name: "Truck 18", type: "Light Truck",  driver: "In Service",     litres: 18,  cost: 280,  efficiency: 0,   kmDriven: 0,   idleLitres: 0  },
    ],

    // ── Hourly Fuel Today (6 AM – 6 PM) ─────────────────────
    hourlyToday: [
      { h: "6 AM",  litres: 62,  cost: 963  },
      { h: "7 AM",  litres: 148, cost: 2298 },
      { h: "8 AM",  litres: 210, cost: 3255 },
      { h: "9 AM",  litres: 228, cost: 3538 },
      { h: "10 AM", litres: 244, cost: 3782 },
      { h: "11 AM", litres: 232, cost: 3596 },
      { h: "12 PM", litres: 218, cost: 3379 },
      { h: "1 PM",  litres: 196, cost: 3038 },
      { h: "2 PM",  litres: 188, cost: 2914 },
      { h: "3 PM",  litres: 114, cost: 1767 },
      { h: "4 PM",  litres: 0,   cost: 0    },
      { h: "5 PM",  litres: 0,   cost: 0    },
    ],

    // ── Monthly Trend (last 5 weeks) ─────────────────────────
    monthlyTrend: [
      { week: "W1 (Jan 27)", litres: 14820, cost: 229950, efficiency: 4.0, trips: 228 },
      { week: "W2 (Feb 03)", litres: 15340, cost: 238030, efficiency: 3.9, trips: 241 },
      { week: "W3 (Feb 10)", litres: 13980, cost: 216860, efficiency: 4.2, trips: 219 },
      { week: "W4 (Feb 17)", litres: 14460, cost: 224330, efficiency: 4.1, trips: 234 },
      { week: "W5 (Feb 24)", litres: 11400, cost: 177010, efficiency: 4.2, trips: 196 },
    ],
  },

  // ── Compliance ─────────────────────────────────────────────
  compliance: [
    { vehicleId: "TRK-001", name: "Truck 01", plate: "MH-12-AB-1234", insurance: "31 Aug 2026", puc: "15 Apr 2026", permit: "30 Jun 2026", fitness: "20 Mar 2026", regExpiry: "12 Dec 2028", driverLicense: "Ravi Kumar – Valid till Oct 2028" },
    { vehicleId: "TRK-002", name: "Truck 02", plate: "MH-12-AB-1235", insurance: "14 Mar 2026", puc: "28 Feb 2026", permit: "15 Mar 2026", fitness: "10 Feb 2026", regExpiry: "18 Nov 2027", driverLicense: "Suresh Nair – Valid till Jul 2027" },
    { vehicleId: "TRK-003", name: "Truck 03", plate: "MH-12-AC-3456", insurance: "22 Sep 2026", puc: "30 Apr 2026", permit: "20 Sep 2026", fitness: "15 May 2026", regExpiry: "08 Jul 2029", driverLicense: "Priya Mehta – Valid till Feb 2029" },
    { vehicleId: "TRK-004", name: "Truck 04", plate: "MH-14-BD-5678", insurance: "05 Feb 2026", puc: "12 Mar 2026", permit: "28 Feb 2026", fitness: "01 Mar 2026", regExpiry: "22 Apr 2026", driverLicense: "Anjali Rao – Valid till Sep 2026" },
    { vehicleId: "TRK-005", name: "Truck 05", plate: "MH-14-BD-5679", insurance: "18 Dec 2025", puc: "25 Jan 2026", permit: "10 Jan 2026", fitness: "15 Dec 2025", regExpiry: "30 Jun 2027", driverLicense: "Vikram Patel – Expires 15 Apr 2026" },
    { vehicleId: "TRK-008", name: "Truck 08", plate: "MH-14-EG-6789", insurance: "28 Jul 2026", puc: "05 Apr 2026", permit: "25 Jul 2026", fitness: "10 Apr 2026", regExpiry: "14 Aug 2027", driverLicense: "Arjun Singh – Valid till Jun 2027" },
    { vehicleId: "TRK-019", name: "Truck 19", plate: "MH-14-ST-9012", insurance: "10 Jan 2026", puc: "18 Jan 2026", permit: "05 Jan 2026", fitness: "08 Jan 2026", regExpiry: "16 Mar 2026", driverLicense: "—" },
  ],

  // ── Alerts ────────────────────────────────────────────────
  alerts: [
    { id: "FA-001", severity: "Critical", vehicleId: "TRK-005", vehicle: "Truck 05", type: "Engine Fault",    message: "Abnormal vibration & overheating. Breakdown risk in ~12 days.", time: "08:42 AM", assignee: "Workshop Team A" },
    { id: "FA-002", severity: "Critical", vehicleId: "TRK-019", vehicle: "Truck 19", type: "GPS Offline",     message: "Device offline. Last seen 14h ago near Solapur.", time: "06:10 AM", assignee: "Fleet Manager" },
    { id: "FA-003", severity: "Critical", vehicleId: "TRK-016", vehicle: "Truck 16", type: "Major Service",   message: "Engine overhaul in progress at Pune workshop.", time: "Yesterday", assignee: "Workshop Team B" },
    { id: "FA-004", severity: "Critical", vehicleId: "TRK-005", vehicle: "Truck 05", type: "Compliance",      message: "Insurance & fitness certificate expired. Immediate action needed.", time: "2 days ago", assignee: "Admin" },
    { id: "FA-005", severity: "Warning",  vehicleId: "TRK-004", vehicle: "Truck 04", type: "Overdue Service", message: "Service overdue by 12 days. Engine temp running high.", time: "09:15 AM", assignee: "Workshop Team A" },
    { id: "FA-006", severity: "Warning",  vehicleId: "TRK-008", vehicle: "Truck 08", type: "Driver Behavior", message: "Arjun Singh idling 55 min. 8 harsh braking events today.", time: "10:02 AM", assignee: "Fleet Manager" },
    { id: "FA-007", severity: "Warning",  vehicleId: "TRK-002", vehicle: "Truck 02", type: "Low Fuel",        message: "Fuel at 44%. Refill before Nashik reach.", time: "10:30 AM", assignee: "Driver" },
    { id: "FA-008", severity: "Warning",  vehicleId: "TRK-012", vehicle: "Truck 12", type: "Idle Engine",     message: "Engine running idle at depot for 87 min. Fuel waste.", time: "11:00 AM", assignee: "Depot Manager" },
    { id: "FA-009", severity: "Info",     vehicleId: "EV-001",  vehicle: "EV Truck 01", type: "Trip Complete", message: "Arrived Pune. Next charge: 80% → 100% at Charging Hub.", time: "09:50 AM", assignee: "—" },
    { id: "FA-010", severity: "Info",     vehicleId: "TRK-003", vehicle: "Truck 03", type: "Trip Started",    message: "Departed Nashik toward Shirdi. ETA 55 min.", time: "09:05 AM", assignee: "—" },
  ],

  // ── Weekly KPI Trend ──────────────────────────────────────
  weeklyKpi: [
    { d: "Mon", utilization: 62, trips: 38, fuelEff: 4.1 },
    { d: "Tue", utilization: 58, trips: 34, fuelEff: 4.3 },
    { d: "Wed", utilization: 65, trips: 41, fuelEff: 3.9 },
    { d: "Thu", utilization: 55, trips: 30, fuelEff: 4.4 },
    { d: "Fri", utilization: 60, trips: 36, fuelEff: 4.2 },
    { d: "Sat", utilization: 42, trips: 22, fuelEff: 4.6 },
    { d: "Sun", utilization: 58, trips: 31, fuelEff: 4.2 },
  ],
};
